module.exports = __webpack_public_path__ + "img/c181d71.jpg";